// extracted by mini-css-extract-plugin
export var container = "_dx-0";
export var infoIcon = "_dx-2";
export var internalLabel = "_dx-3";
export var titleRowCol = "_dx-1";